import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { get } from 'lodash';
import { push } from 'connected-react-router';
import { createUserForm } from 'services/users/duck';
import { fetchList as fetchBrandList } from 'services/brands/duck';
import EditUserForm from 'components/organisms/forms/EditUser';

class CreateUserContainer extends Component {
    componentDidMount() {
        this.props.fetchBrandList();
    }

    render() {
        const brandsWithSubDomains = this.props.brands.filter(brand => get(brand, 'meta.whitelabel.subdomain'));

        return (
            <EditUserForm
                brands={brandsWithSubDomains}
                dispatch={this.props.dispatch}
                handleSubmit={this.props.handleSubmit.bind(null, createUserForm)}
                handleCancel={() => (this.props.push('/admin/users'))}
                selectedBrandId={this.props.selectedBrandId} >
                {this.props.children}
            </EditUserForm>
        );
    }
}

const form = 'createUser';
const formSelector = formValueSelector(form);

const mapStateToProps = state => ({
    brands: state.brands.list,
    selectedBrandId: formSelector(state, 'brandId')
});

export default compose(
    connect(mapStateToProps, {
        push,
        fetchBrandList }),
    reduxForm({
        form,
        enableReinitialize: true
    })
)(CreateUserContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/users/CreateUserContainer.js